import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "10",
  preserveAspectRatio: "none",
  viewBox: "0 0 15 11"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      stroke: "currentColor",
      d: "M5.089 10.172a.83.83 0 0 1-.587-.243L.825 6.257a.83.83 0 1 1 1.173-1.175L5.09 8.168 12.445.822a.83.83 0 1 1 1.174 1.175L5.676 9.929a.83.83 0 0 1-.587.243Z",
      "data-name": "Path 1478"
    }, null, -1)
  ])))
}
export default { render: render }